import { Helpers } from '../../helpers';
import { IConstraintMaxFracFleetPerArea } from '../../interfaces/iconstraint-max-frac-fleet-per-area';
import { AreaType } from '../area-type';
import { ConstraintMaxFracFleetPerAreaDetail } from '../constraint-max-frac-fleet-per-area-detail';
import { Scenario } from '../scenario';

export class ConstraintMaxFracFleetPerAreaBase {
  ConstraintMaxFracFleetPerAreaId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintMaxFracFleetPerAreaDetails_ConstraintMaxFracFleetPerArea?: Array<ConstraintMaxFracFleetPerAreaDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintMaxFracFleetPerArea) {
    if (item) {

      this.ConstraintMaxFracFleetPerAreaId = item.ConstraintMaxFracFleetPerAreaId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintMaxFracFleetPerAreaDetails_ConstraintMaxFracFleetPerArea = Helpers.createClassArray(ConstraintMaxFracFleetPerAreaDetail, item.ConstraintMaxFracFleetPerAreaDetails_ConstraintMaxFracFleetPerArea);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}